import { object, string, ref } from 'yup'
const resetPasswordCheck = object().shape({
  password: string()
    .required('Please enter new password.')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
 'Password must contain min. 8 and max. 15 characters, one uppercase, one lowercase, one number, and one special character ( $ ! @ ... )',    ),
  confirmPassword: string()
    .required('Please enter confirm password.')
    .oneOf([ref('password')], 'New password and confirm password does not match.'),
})

export default resetPasswordCheck
